import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
import { Wind, Sofa, Sparkles } from 'lucide-react';
export function MechanismSection() {
  return <Section className="bg-[#4A9BD9] text-white" data-id="element-56">
      <FadeIn data-id="element-57">
        <div className="text-center mb-12" data-id="element-58">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-59">
            La solución: el Mapa de Olor 4Z
          </h2>
          <p className="text-xl text-white/90 max-w-2xl mx-auto" data-id="element-60">
            Este es el cambio: dejar de limpiar por impulso y empezar a limpiar
            por <strong data-id="element-61">zonas estratégicas</strong>.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-62">
          <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl border border-white/20" data-id="element-63">
            <div className="flex items-center gap-3 mb-3" data-id="element-64">
              <Wind className="w-6 h-6 text-[#FDF8F3]" data-id="element-65" />
              <h3 className="text-xl font-bold" data-id="element-66">Z1 Aire</h3>
            </div>
            <p className="text-white/80" data-id="element-67">
              Lo que sientes apenas entras. La primera impresión olfativa de tu
              casa.
            </p>
          </div>

          <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl border border-white/20" data-id="element-68">
            <div className="flex items-center gap-3 mb-3" data-id="element-69">
              <Sofa className="w-6 h-6 text-[#FDF8F3]" data-id="element-70" />
              <h3 className="text-xl font-bold" data-id="element-71">Z2 Textiles</h3>
            </div>
            <p className="text-white/80" data-id="element-72">
              Lo que absorbe y lo suelta cuando alguien se sienta. Sofás,
              cortinas, alfombras.
            </p>
          </div>

          <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl border border-white/20" data-id="element-73">
            <div className="flex items-center gap-3 mb-3" data-id="element-74">
              <Sparkles className="w-6 h-6 text-[#FDF8F3]" data-id="element-75" />
              <h3 className="text-xl font-bold" data-id="element-76">Z3 Superficies</h3>
            </div>
            <p className="text-white/80" data-id="element-77">
              La película invisible en pisos, zócalos y esquinas que retiene
              partículas.
            </p>
          </div>

          <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl border border-white/20" data-id="element-78">
            <div className="flex items-center gap-3 mb-3" data-id="element-79">
              <div className="w-6 h-6 text-[#FDF8F3]" data-id="element-80" />
              <h3 className="text-xl font-bold" data-id="element-81">Z4 Fuente</h3>
            </div>
            <p className="text-white/80" data-id="element-82">
              Lo que reinstala el olor constantemente (cama, arenero, accidentes
              viejos).
            </p>
          </div>
        </div>

        <div className="mt-12 text-center bg-white/10 rounded-lg p-6" data-id="element-83">
          <p className="text-xl font-bold" data-id="element-84">
            Cuando atacas las 4, el olor no “baja”:{' '}
            <span className="text-[#FDF8F3] underline decoration-2 underline-offset-4" data-id="element-85">
              se rompe el ciclo.
            </span>
          </p>
        </div>
      </FadeIn>
    </Section>;
}